import React, {useMemo} from 'react';
import moment from 'moment';

export default ({item, calculatePositionOfStickyHeaders, config, index}) => {
  const joint = useMemo(
    () =>
      item.registrationDate
        ? moment(item.registrationDate).format('YYYY-MM-DD')
        : '-',
    [item.createdAt]
  );
  return (
    <td
      className={`text-center ${index === 0 ? 'first-cell' : ''}`}
      style={calculatePositionOfStickyHeaders(config)}
    >
      {joint}
    </td>
  );
};
